import React from "react";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Turns issue-photo ids or "/api/issue-photos/<id>" paths into absolute URLs.
export function issuePhotoUrl(p) {
  const s = String(p || "");
  return s.startsWith("/api/") ? `${BASE}${s}` : `${BASE}/api/issue-photos/${s}`;
}

// Compact clickable thumbnails (auth via cookie). Opens full size in a new tab.
export function IssuePhotos({ photos = [], size = "h-12", testid = "issue-photos" }) {
  if (!photos || photos.length === 0) return null;
  return (
    <span className="inline-flex items-center gap-1" data-testid={testid}>
      {photos.map((p, i) => {
        const url = issuePhotoUrl(p);
        return (
          <a key={`${p}-${i}`} href={url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
             className="inline-block rounded border border-slate-300 overflow-hidden hover:ring-2 hover:ring-red-400" title="Open photo">
            <img src={url} alt={`issue ${i + 1}`} className={`${size} w-auto object-cover`} loading="lazy" />
          </a>
        );
      })}
    </span>
  );
}
